export const notificationTopic = "backend/notifications/";
export const notificationResponseTopic = "apps/notifications/";
export const logRequestTopic = "apps/logrequests/";
export const logRequestResponseTopic = "devices/logrequests/";
export const logsTopic = "devices/logs/";
export const lastWillTopic = "apps/lastwill/";